<script setup>
import { computed } from "vue";
import { useVacancies } from "@/stores/vacancies.js";
import { declOfNum } from "@/lib/declOfNum.js";
import VacancyCard from "@/components/VacancyCard.vue";
import TheLoader from "@/components/TheLoader.vue";

const store = useVacancies();

const countInfo = computed(() => {
  if (store.count === 0) return "Вакансий не найдено";

  return declOfNum(store.count, [
    `Найдена ${store.count} вакансия`,
    `Найдены ${store.count} вакансии`,
    `Найдено ${store.count} вакансий`,
  ]);
});
</script>

<template>
  <template v-if="store.loadingVacancies">
    <p>
      <span :class="$style.loader"><TheLoader /></span>
      Загружаем вакансии...
    </p>
  </template>
  <template v-else>
    <p v-text="countInfo" />
    <VacancyCard
      v-for="vacancy of store.vacancies"
      :key="vacancy.id"
      v-bind="vacancy"
    />
  </template>
</template>

<style module>
.loader {
  display: inline-block;
  color: #ed1651;
  margin-right: 1em;
}
</style>
